import axios from "axios";

export async function getComponentsCatalog() {
  const url = `/guidelines/catalog/catalog.json`;
  try {
    const response = await axios.get(url, {
      responseType: "json",
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching components catalog:", error);
    throw error;
  }
}

export function getComponentsArray(catalog) {
  const arr = [];
  catalog.forEach((el) => arr.push(el.name));
  return arr;
}

export async function getVersion() {
  const url = `/guidelines/version/version.json`;
  try {
    const response = await axios.get(url, {
      responseType: "json",
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching version:", error);
    throw error;
  }
}
